export default __webpack_public_path__ + "static/media/icono_ig.195a65e2.svg";